import React, { useState } from 'react';

const styles = {
  canvas: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '48px 32px 80px',
  },
  header: {
    textAlign: 'center',
    marginBottom: 56,
    position: 'relative',
  },
  headerLine: {
    width: 120,
    height: 2,
    margin: '24px auto 0',
    background: 'linear-gradient(90deg, transparent, #2563EB, transparent)',
  },
  badge: {
    display: 'inline-block',
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: '#0891B2',
    background: '#E0F7FA',
    border: '1px solid rgba(8,145,178,0.2)',
    padding: '6px 16px',
    borderRadius: 20,
    marginBottom: 20,
  },
  h1: {
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: -0.5,
    color: '#0F172A',
    marginBottom: 8,
  },
  headerDesc: {
    fontSize: 14,
    color: '#5A6B82',
    maxWidth: 620,
    margin: '0 auto',
    lineHeight: 1.6,
  },
  connector: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px 0',
  },
  connectorLine: {
    width: 2,
    height: 36,
    background: 'linear-gradient(180deg, #B0B8CC, #D8DCE6)',
    position: 'relative',
  },
  connectorArrow: {
    position: 'absolute',
    bottom: -4,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '6px solid #B0B8CC',
  },
  node: {
    borderRadius: 14,
    padding: '24px 28px',
    position: 'relative',
    border: '1px solid #D8DCE6',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)',
  },
  nodeLabel: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 10,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
    marginBottom: 8,
    fontWeight: 500,
  },
  nodeTitle: { fontSize: 17, fontWeight: 700, marginBottom: 6, color: '#0F172A' },
  nodeDesc: { fontSize: 13, color: '#5A6B82', lineHeight: 1.55 },
  phaseDivider: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    margin: '32px auto 24px',
    maxWidth: 900,
  },
  phaseLine: { flex: 1, height: 1, background: '#D8DCE6' },
  phaseText: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 10,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: '#5A6B82',
    whiteSpace: 'nowrap',
  },
  exampleTabs: {
    display: 'flex',
    gap: 8,
    marginTop: 14,
    marginBottom: 10,
    flexWrap: 'wrap',
  },
  tabBtn: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 11,
    fontWeight: 600,
    padding: '6px 16px',
    borderRadius: 8,
    border: '1.5px solid #D8DCE6',
    background: '#F0F2F8',
    color: '#5A6B82',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  sourceCard: {
    background: '#FFFFFF',
    border: '1px solid #C7D2FE',
    borderRadius: 10,
    padding: '14px 14px',
    textAlign: 'center',
  },
  sourceCardHighlight: {
    borderColor: '#4F46E5',
    background: '#EEF2FF',
  },
  srcIcon: { fontSize: 24, marginBottom: 8 },
  srcH4: { fontSize: 12, fontWeight: 700, color: '#4F46E5', marginBottom: 4, margin: 0 },
  srcP: { fontSize: 11, color: '#5A6B82', lineHeight: 1.45, margin: 0 },
  tag: {
    display: 'inline-block',
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 9,
    padding: '3px 8px',
    borderRadius: 4,
    background: '#EEF2FF',
    border: '1px solid #C7D2FE',
    color: '#4F46E5',
    margin: '2px 2px',
  },
  processCard: {
    background: '#FFFFFF',
    border: '1px solid #DDD6FE',
    borderRadius: 10,
    padding: '14px 16px',
  },
  processH4: { fontSize: 12, fontWeight: 600, color: '#7C3AED', marginBottom: 4, margin: 0 },
  processP: { fontSize: 12, color: '#5A6B82', lineHeight: 1.5, margin: 0 },
  jsonBlock: {
    marginTop: 16,
    background: '#1E293B',
    border: '1px solid #334155',
    borderRadius: 10,
    padding: 20,
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 11.5,
    lineHeight: 1.7,
    overflowX: 'auto',
    color: '#E2E8F0',
    whiteSpace: 'pre',
  },
  classCard: {
    background: '#FFFFFF',
    border: '1px solid #D8DCE6',
    borderRadius: 12,
    padding: 16,
    textAlign: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  classIcon: { fontSize: 20, marginBottom: 8 },
  classH4: { fontSize: 12, fontWeight: 700, color: '#0F172A', marginBottom: 4, margin: 0 },
  classP: { fontSize: 11, color: '#5A6B82', lineHeight: 1.45, margin: 0 },
  pill: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 11,
    padding: '5px 12px',
    borderRadius: 20,
    background: '#E0F7FA',
    border: '1px solid #A5F3FC',
    color: '#0891B2',
  },
  stepNum: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 10,
    fontWeight: 700,
    minWidth: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    flexShrink: 0,
    marginTop: 1,
  },
  stepLi: {
    fontSize: 12.5,
    color: '#5A6B82',
    padding: '6px 0',
    borderBottom: '1px solid rgba(0,0,0,0.05)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    lineHeight: 1.5,
    listStyle: 'none',
  },
  branchLabel: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 10,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontWeight: 600,
    padding: '4px 12px',
    borderRadius: 12,
    display: 'inline-block',
    marginBottom: 12,
  },
  loopBack: {
    maxWidth: 820,
    margin: '16px auto 0',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 20px',
    background: '#FFE4E6',
    border: '1px dashed #FCA5A5',
    borderRadius: 10,
  },
  footerNote: {
    textAlign: 'center',
    marginTop: 48,
    paddingTop: 24,
    borderTop: '1px solid #D8DCE6',
  },
};

const JK = ({ children }) => <span style={{ color: '#86EFAC' }}>{children}</span>;
const JS = ({ children }) => <span style={{ color: '#93C5FD' }}>{children}</span>;
const JN = ({ children }) => <span style={{ color: '#FCD34D' }}>{children}</span>;
const JC = ({ children }) => <span style={{ color: '#94A3B8', fontStyle: 'italic' }}>{children}</span>;

const Connector = ({ height }) => (
  <div style={styles.connector}>
    <div style={{ ...styles.connectorLine, height: height || 36 }}>
      <div style={styles.connectorArrow} />
    </div>
  </div>
);

const PhaseDivider = ({ text }) => (
  <div style={styles.phaseDivider}>
    <div style={styles.phaseLine} />
    <span style={styles.phaseText}>{text}</span>
    <div style={styles.phaseLine} />
  </div>
);

const ExampleTabs = ({ active, onSelect, labels }) => (
  <div style={styles.exampleTabs}>
    {labels.map((label, i) => {
      const key = ['a', 'b', 'c'][i];
      const activeStyles = {
        a: { background: '#DBEAFE', borderColor: '#2563EB', color: '#2563EB' },
        b: { background: '#FEF3C7', borderColor: '#D97706', color: '#D97706' },
        c: { background: '#F0FDF4', borderColor: '#059669', color: '#059669' },
      };
      return (
        <button
          key={key}
          style={{ ...styles.tabBtn, ...(active === key ? activeStyles[key] : {}) }}
          onClick={() => onSelect(key)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

const ExampleTag = ({ variant, children }) => {
  const tagStyles = {
    a: { background: '#DBEAFE', color: '#2563EB' },
    b: { background: '#FEF3C7', color: '#D97706' },
    c: { background: '#F0FDF4', color: '#059669' },
  };
  return (
    <span style={{
      display: 'inline-block', fontFamily: "'JetBrains Mono', monospace",
      fontSize: 9, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase',
      padding: '3px 10px', borderRadius: 6, marginBottom: 8, ...tagStyles[variant]
    }}>
      {children}
    </span>
  );
};

const LLMClassificationDemo = () => {
  const [activeExample, setActiveExample] = useState('a');


  return (
    <div className="status-report" style={{ background: '#F7F8FC', minHeight: '100vh' }}>
      {/* HEADER */}
      <div style={styles.header}>
        <div style={styles.badge}>High-Level Process Diagram</div>
        <h1 style={styles.h1}>LLM-Based Classification & Extraction</h1>
        <p style={styles.headerDesc}>
          ACORD Certificate Request Processing — multi-source email intake pipeline with per-document
          classification, per-sheet extraction, and structured JSON output. Illustrated with two real requests.
        </p>
        <div style={styles.headerLine} />
      </div>

      {/* PHASE 1: INTAKE */}
      <PhaseDivider text="Step 1 — Intake & Decomposition" />

      {/* Trigger Node */}
      <div style={{
        ...styles.node,
        background: 'linear-gradient(135deg, #FFFFFF 0%, #DBEAFE 100%)',
        borderColor: '#BFDBFE',
        textAlign: 'center',
        maxWidth: 560,
        margin: '0 auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 12 }}>
          <span style={{ fontSize: 22 }}>📧</span>
        </div>
        <div style={{ ...styles.nodeLabel, color: '#2563EB' }}>Trigger</div>
        <div style={styles.nodeTitle}>Inbound Email Received</div>
        <div style={styles.nodeDesc}>
          Email arrives in the monitored certificate request mailbox. System captures subject line,
          body content, sender metadata, and inventories all attachments.
        </div>

        <ExampleTabs
          active={activeExample}
          onSelect={setActiveExample}
          labels={['Example A — Astro Pak COI', 'Example B — Omnicom E&O', 'Example C — Jani-King / GFL']}
        />

        {activeExample === 'a' && (
          <div style={{ padding: 10, background: '#DBEAFE', borderRadius: 8, border: '1px dashed #93C5FD', textAlign: 'left' }}>
            <ExampleTag variant="a">Example A</ExampleTag><br />
            <span style={styles.nodeDesc}>
              <strong style={{ color: '#2563EB' }}>From:</strong> Christina Reese (creese@astropak.com)<br />
              <strong style={{ color: '#2563EB' }}>Subject:</strong> "URGENT Astro Pak COI Request for Heavy Equipment Movers & Installation, LLC"<br />
              <strong style={{ color: '#2563EB' }}>Priority:</strong> High · <strong style={{ color: '#2563EB' }}>Attachments:</strong> 1 PDF · <strong style={{ color: '#2563EB' }}>Body:</strong> Detailed bullet list with all request fields
            </span>
          </div>
        )}
        {activeExample === 'b' && (
          <div style={{ padding: 10, background: '#FEF3C7', borderRadius: 8, border: '1px dashed #FCD34D', textAlign: 'left' }}>
            <ExampleTag variant="b">Example B</ExampleTag><br />
            <span style={styles.nodeDesc}>
              <strong style={{ color: '#D97706' }}>From:</strong> Christina Johnson / Omnicom (christina.johnson@omc.com)<br />
              <strong style={{ color: '#D97706' }}>Subject:</strong> "Omnicom E&O request for Insurance (Mercury)"<br />
              <strong style={{ color: '#D97706' }}>Priority:</strong> Normal · <strong style={{ color: '#D97706' }}>Attachments:</strong> 1 XLSX · <strong style={{ color: '#D97706' }}>Body:</strong> Sparse — "please find request attached for our client, GNAM"
            </span>
          </div>
        )}
        {activeExample === 'c' && (
          <div style={{ padding: 10, background: '#F0FDF4', borderRadius: 8, border: '1px dashed #86EFAC', textAlign: 'left' }}>
            <ExampleTag variant="c">Example C</ExampleTag><br />
            <span style={styles.nodeDesc}>
              <strong style={{ color: '#059669' }}>From:</strong> David Knight (dknight@janiking.com) — Director of Risk Management, Jani-King International<br />
              <strong style={{ color: '#059669' }}>Subject:</strong> "FW: Jani-King and GFL Next Steps"<br />
              <strong style={{ color: '#059669' }}>Priority:</strong> Normal · <strong style={{ color: '#059669' }}>Attachments:</strong> 1 DOCX · <strong style={{ color: '#059669' }}>Body:</strong> Short request + forwarded email chain with cert holder details from GFL
            </span>
          </div>
        )}
      </div>

      <Connector />

      {/* Document Decomposition Node */}
      <div style={{
        ...styles.node,
        background: 'linear-gradient(135deg, #FFFFFF 0%, #EEF2FF 100%)',
        borderColor: '#A5B4FC',
        maxWidth: 900,
        margin: '0 auto',
      }}>
        <div style={{ ...styles.nodeLabel, color: '#4F46E5' }}>Document Decomposition</div>
        <div style={styles.nodeTitle}>Identify & Separate All Information Sources</div>
        <div style={styles.nodeDesc}>
          The system inventories every source of information in the inbound email and decomposes them
          into individually classifiable units. Each source is processed independently before aggregation.
        </div>

        <ExampleTabs
          active={activeExample}
          onSelect={setActiveExample}
          labels={['Example A — Astro Pak', 'Example B — Omnicom', 'Example C — Jani-King']}
        />

        {activeExample === 'a' && (
          <div className="achievement-cards" style={{ marginTop: 16 }}>
            <div style={{ ...styles.sourceCard, ...styles.sourceCardHighlight }}>
              <div style={styles.srcIcon}>📝</div>
              <h4 style={styles.srcH4}>Email Body</h4>
              <p style={styles.srcP}>Structured bullet points listing cert holder, address, additional insured, project ref, deadline, and delivery instructions.</p>
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #A5B4FC' }}>
                <span style={styles.tag}>Role → Instructions + Data</span>
              </div>
            </div>
            <div style={{ ...styles.sourceCard, ...styles.sourceCardHighlight }}>
              <div style={styles.srcIcon}>📄</div>
              <h4 style={styles.srcH4}>PDF: HEMI PO Insurance requirements.pdf</h4>
              <p style={styles.srcP}>ACORD 25 sample with prefilled coverage limits (GL, Auto, Umbrella, WC), additional insured flags, waiver of subrogation, and endorsement form requirements.</p>
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #A5B4FC' }}>
                <span style={styles.tag}>Role → Data (coverage reqs)</span>
              </div>
            </div>
          </div>
        )}
        {activeExample === 'b' && (
          <div className="achievement-cards" style={{ marginTop: 16 }}>
            <div style={styles.sourceCard}>
              <div style={styles.srcIcon}>📝</div>
              <h4 style={styles.srcH4}>Email Body</h4>
              <p style={styles.srcP}>Sparse — only says "please find request attached for our client, GNAM." No structured data fields in the body itself. Acts purely as a pointer to the attachment.</p>
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #A5B4FC' }}>
                <span style={styles.tag}>Role → Instructions only</span>
              </div>
            </div>
            <div style={{ ...styles.sourceCard, ...styles.sourceCardHighlight }}>
              <div style={styles.srcIcon}>📊</div>
              <h4 style={styles.srcH4}>XLSX: Mercury Public Affairs LLC Request E&O.xlsx</h4>
              <p style={styles.srcP}>Excel workbook with the E&O insurance request. <strong>Each sheet classified individually</strong> — may contain client info, coverage requirements, certificate holder details, and special instructions.</p>
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #A5B4FC' }}>
                <span style={styles.tag}>Sheet 1 → Request form data</span>
                <span style={styles.tag}>Sheet 2 → Coverage details</span>
                <span style={styles.tag}>Sheet N → Per-sheet extraction</span>
              </div>
            </div>
          </div>
        )}
        {activeExample === 'c' && (
          <div className="achievement-cards" style={{ marginTop: 16 }}>
            <div style={{ ...styles.sourceCard, ...styles.sourceCardHighlight }}>
              <div style={styles.srcIcon}>📝</div>
              <h4 style={styles.srcH4}>Email Body (with Forwarded Thread)</h4>
              <p style={styles.srcP}>Short top-level request: "issue a COI based on the attached request form." But the <strong>forwarded email chain below</strong> contains rich data from GFL's Jack Dalzell: cert holder name & address, description of operations, additional insured wording, waiver of subrogation, and 30-day notice requirements.</p>
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #A5B4FC' }}>
                <span style={styles.tag}>Role → Instructions + Data</span>
                <span style={styles.tag}>Fwd chain = critical data source</span>
              </div>
            </div>
            <div style={{ ...styles.sourceCard, ...styles.sourceCardHighlight }}>
              <div style={styles.srcIcon}>📋</div>
              <h4 style={styles.srcH4}>DOCX: GFL COI request.docx</h4>
              <p style={styles.srcP}>Word document containing the formal COI request form with structured fields for certificate holder, coverage types, limits, and special endorsement requirements.</p>
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #A5B4FC' }}>
                <span style={styles.tag}>Role → Data (request form)</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* PHASE 2: CLASSIFICATION */}
      <PhaseDivider text="Step 2 — Per-Source Classification & Extraction" />

      <div style={{
        ...styles.node,
        background: 'linear-gradient(135deg, #FFFFFF 0%, #EDE9FE 100%)',
        borderColor: '#C4B5FD',
        maxWidth: 900,
        margin: '0 auto',
      }}>
        <div style={{ ...styles.nodeLabel, color: '#7C3AED' }}>LLM Engine — Applied to Each Source Independently</div>
        <div style={styles.nodeTitle}>Classify & Extract Per Document / Per Sheet</div>
        <div style={styles.nodeDesc}>
          The LLM processes each decomposed source as its own unit. For Excel files, each sheet is
          classified and extracted separately. Results are tagged with their source origin.
        </div>
        <div className="achievement-cards" style={{ marginTop: 16 }}>
          <div style={styles.processCard}>
            <h4 style={styles.processH4}>① Source Classification</h4>
            <p style={styles.processP}>Classify each source's role: does it contain <strong>instructions</strong> (what the requestor wants done), <strong>data</strong> (certificate holder info, policy details, limits), or <strong>both</strong>? Tag source type accordingly.</p>
          </div>
          <div style={styles.processCard}>
            <h4 style={styles.processH4}>② Intent Classification</h4>
            <p style={styles.processP}>Determine overall request intent (New / Renewal / Update / Other). Each source may contribute to or confirm the intent. Confidence &lt; 90% routes to "Other."</p>
          </div>
          <div style={styles.processCard}>
            <h4 style={styles.processH4}>③ Field Extraction</h4>
            <p style={styles.processP}>Extract structured data per source: insured name, certificate holder(s), policy types (GL, auto, WC, umbrella), limits, policy numbers, effective/expiration dates, additional insured requirements.</p>
          </div>
          <div style={styles.processCard}>
            <h4 style={styles.processH4}>④ Instruction Extraction</h4>
            <p style={styles.processP}>Capture explicit instructions from each source: special endorsements requested, rush/priority flags, specific wording requirements, distribution lists, deadlines, and any conditional logic.</p>
          </div>
        </div>
        <div style={{ ...styles.processCard, marginTop: 12 }}>
          <h4 style={styles.processH4}>⑤ Completeness Check & Cross-Source Reconciliation</h4>
          <p style={styles.processP}>After all sources are individually processed, the system cross-references extracted fields across sources. Data from the email body, PDF attachments, Excel sheets, and DOCX files are reconciled — conflicts are flagged, gaps are identified, and a unified completeness assessment is produced against the required ACORD form fields.</p>
        </div>
      </div>

      {/* PHASE 3: JSON PACKAGING */}
      <PhaseDivider text="Step 3 — Structured JSON Output" />

      <div style={{
        ...styles.node,
        background: 'linear-gradient(135deg, #FFFFFF 0%, #D1FAE5 100%)',
        borderColor: '#6EE7B7',
        maxWidth: 900,
        margin: '0 auto',
      }}>
        <div style={{ ...styles.nodeLabel, color: '#059669' }}>Aggregation Layer</div>
        <div style={styles.nodeTitle}>Package All Extractions into Structured JSON</div>
        <div style={styles.nodeDesc}>
          All per-source classifications, extracted data, and instructions are consolidated into a
          clean JSON payload with full source provenance.
        </div>

        <ExampleTabs
          active={activeExample}
          onSelect={setActiveExample}
          labels={['Example A — Astro Pak (Complete)', 'Example B — Omnicom (Incomplete)', 'Example C — Jani-King (Complete)']}
        />

        {activeExample === 'a' && (
          <div style={styles.jsonBlock}>
            <JC>{'// Real example: Astro Pak COI request for Heavy Equipment Movers'}</JC>{'\n'}
{`{`}{'\n'}
{'  '}<JK>"request_id"</JK>: <JS>"REQ-2026-00227-001"</JS>,{'\n'}
{'  '}<JK>"email_metadata"</JK>: {'{'}{'\n'}
{'    '}<JK>"from"</JK>: <JS>"Christina Reese &lt;creese@astropak.com&gt;"</JS>,{'\n'}
{'    '}<JK>"to"</JK>: <JS>"AstroPakCerts@lockton.com"</JS>,{'\n'}
{'    '}<JK>"subject"</JK>: <JS>"URGENT Astro Pak COI Request for Heavy Equipment Movers..."</JS>,{'\n'}
{'    '}<JK>"received_at"</JK>: <JS>"2026-02-27T13:29:21Z"</JS>,{'\n'}
{'    '}<JK>"priority"</JK>: <JS>"high"</JS>{'\n'}
{'  }'},{'\n'}
{'  '}<JK>"overall_classification"</JK>: {'{ '}<JK>"intent"</JK>: <JS>"new_certificate"</JS>, <JK>"confidence"</JK>: <JN>0.97</JN>{' }'},{'\n'}
{'  '}<JK>"sources"</JK>: [{'\n'}
{'    {'}{'\n'}
{'      '}<JK>"source_type"</JK>: <JS>"email_body"</JS>,{'\n'}
{'      '}<JK>"source_role"</JK>: <JS>"instructions_and_data"</JS>,{'\n'}
{'      '}<JK>"instructions_extracted"</JK>: [{'\n'}
{'        '}<JS>"Issue new COI for Heavy Equipment Movers & Installation, LLC"</JS>,{'\n'}
{'        '}<JS>"Send certificate to: g.falaschetti@hemisystems.com"</JS>,{'\n'}
{'        '}<JS>"CC creese@astropak.com on the email to customer"</JS>,{'\n'}
{'        '}<JS>"See attached COI sample — note additional insured requirements"</JS>,{'\n'}
{'        '}<JS>"URGENT — COI needed by 2/27/2026"</JS>{'\n'}
{'      ]'},{'\n'}
{'      '}<JK>"data_extracted"</JK>: {'{'}{'\n'}
{'        '}<JK>"certificate_holder"</JK>: <JS>"Heavy Equipment Movers & Installation, LLC"</JS>,{'\n'}
{'        '}<JK>"holder_address"</JK>: <JS>"126 Industrial Drive, Maysville, GA 30558"</JS>,{'\n'}
{'        '}<JK>"additional_insured"</JK>: <JS>"Stellar Group @ Brazos River Ventures, LLC"</JS>,{'\n'}
{'        '}<JK>"project_ref"</JK>: <JS>"PO 251240152GF"</JS>,{'\n'}
{'        '}<JK>"date_needed"</JK>: <JS>"2026-02-27"</JS>,{'\n'}
{'        '}<JK>"requestor"</JK>: <JS>"Christina Reese, Customer Relationship Specialist"</JS>{'\n'}
{'      }'}{'\n'}
{'    }'},{'\n'}
{'    {'}{'\n'}
{'      '}<JK>"source_type"</JK>: <JS>"pdf_attachment"</JS>,{'\n'}
{'      '}<JK>"filename"</JK>: <JS>"HEMI PO Insurance requirements.pdf"</JS>,{'\n'}
{'      '}<JK>"source_role"</JK>: <JS>"data"</JS>,{'\n'}
{'      '}<JK>"data_extracted"</JK>: {'{'}{'\n'}
{'        '}<JK>"acord_form_type"</JK>: <JS>"ACORD 25 (2016-03)"</JS>,{'\n'}
{'        '}<JK>"gl_each_occurrence"</JK>: <JS>"1,000,000"</JS>,{'\n'}
{'        '}<JK>"gl_general_aggregate"</JK>: <JS>"2,000,000"</JS>,{'\n'}
{'        '}<JK>"auto_combined_single"</JK>: <JS>"1,000,000"</JS>,{'\n'}
{'        '}<JK>"umbrella_each_occurrence"</JK>: <JS>"2,000,000"</JS>,{'\n'}
{'        '}<JK>"wc_each_accident"</JK>: <JS>"500,000"</JS>,{'\n'}
{'        '}<JK>"additional_insured_gl"</JK>: <JS>"Y"</JS>,{'\n'}
{'        '}<JK>"waiver_of_subrogation_gl"</JK>: <JS>"Y"</JS>,{'\n'}
{'        '}<JK>"endorsement_forms_required"</JK>: [<JS>"CG 20 10 10 01"</JS>, <JS>"CG 20 37 10 01"</JS>]{'\n'}
{'      }'}{'\n'}
{'    }'}{'\n'}
{'  ]'},{'\n'}
{'  '}<JK>"merged_extraction"</JK>: {'{'} <JC>{'// Unified from email body + PDF attachment'}</JC>{'\n'}
{'    '}<JK>"acord_form_type"</JK>: <JS>"ACORD 25"</JS>,{'\n'}
{'    '}<JK>"insured_name"</JK>: <JS>"Astro Pak Corporation"</JS>,{'\n'}
{'    '}<JK>"certificate_holders"</JK>: [{'{'} <JK>"name"</JK>: <JS>"Heavy Equipment Movers & Installation, LLC"</JS>, <JK>"address"</JK>: <JS>"126 Industrial Drive, Maysville, GA 30558"</JS> {'}'}],{'\n'}
{'    '}<JK>"additional_insureds"</JK>: [<JS>"Heavy Equipment Movers & Installation, LLC"</JS>, <JS>"Stellar Group, Inc"</JS>],{'\n'}
{'    '}<JK>"policies"</JK>: [<JS>"GL"</JS>, <JS>"Auto"</JS>, <JS>"Umbrella"</JS>, <JS>"WC"</JS>],{'\n'}
{'    '}<JK>"special_instructions"</JK>: [{'\n'}
{'      '}<JS>"Primary and Non-Contributory basis"</JS>,{'\n'}
{'      '}<JS>"Waiver of Subrogation on GL, Auto, Umbrella, WC"</JS>,{'\n'}
{'      '}<JS>"Additional Insured Endorsement Forms required: CG 20 10 + CG 20 37"</JS>{'\n'}
{'    ]'}{'\n'}
{'  }'},{'\n'}
{'  '}<JK>"completeness"</JK>: {'{'}{'\n'}
{'    '}<JK>"status"</JK>: <JS>"complete"</JS>,{'\n'}
{'    '}<JK>"fields_present"</JK>: [<JS>"cert_holder"</JS>, <JS>"address"</JS>, <JS>"add_insured"</JS>, <JS>"all_coverage_limits"</JS>, <JS>"endorsement_forms"</JS>],{'\n'}
{'    '}<JK>"fields_missing"</JK>: [],{'\n'}
{'    '}<JK>"conflicts"</JK>: []{'\n'}
{'  }'}{'\n'}
{`}`}
          </div>
        )}

        {activeExample === 'b' && (
          <div style={styles.jsonBlock}>
            <JC>{'// Real example: Omnicom E&O request for Mercury Public Affairs (GNAM)'}</JC>{'\n'}
{`{`}{'\n'}
{'  '}<JK>"request_id"</JK>: <JS>"REQ-2026-00226-001"</JS>,{'\n'}
{'  '}<JK>"email_metadata"</JK>: {'{'}{'\n'}
{'    '}<JK>"from"</JK>: <JS>"Christina Johnson (Omnicom) &lt;christina.johnson@omc.com&gt;"</JS>,{'\n'}
{'    '}<JK>"to"</JK>: <JS>"OmnicomCerts@lockton.com"</JS>,{'\n'}
{'    '}<JK>"subject"</JK>: <JS>"Omnicom E&O request for Insurance (Mercury)"</JS>,{'\n'}
{'    '}<JK>"received_at"</JK>: <JS>"2026-02-26T19:24:16Z"</JS>,{'\n'}
{'    '}<JK>"priority"</JK>: <JS>"normal"</JS>{'\n'}
{'  }'},{'\n'}
{'  '}<JK>"overall_classification"</JK>: {'{ '}<JK>"intent"</JK>: <JS>"new_certificate"</JS>, <JK>"confidence"</JK>: <JN>0.93</JN>{' }'},{'\n'}
{'  '}<JK>"sources"</JK>: [{'\n'}
{'    {'}{'\n'}
{'      '}<JK>"source_type"</JK>: <JS>"email_body"</JS>,{'\n'}
{'      '}<JK>"source_role"</JK>: <JS>"instructions"</JS>,{'\n'}
{'      '}<JK>"instructions_extracted"</JK>: [<JS>"See attached request for client GNAM"</JS>],{'\n'}
{'      '}<JK>"data_extracted"</JK>: {'{'} <JK>"client_name_ref"</JK>: <JS>"GNAM"</JS>, <JK>"requestor"</JK>: <JS>"Christina Johnson"</JS> {'}'}{'\n'}
{'    }'},{'\n'}
{'    {'}{'\n'}
{'      '}<JK>"source_type"</JK>: <JS>"xlsx_attachment"</JS>,{'\n'}
{'      '}<JK>"filename"</JK>: <JS>"Mercury Public Affairs LLC Request E&O.xlsx"</JS>,{'\n'}
{'      '}<JK>"sheets"</JK>: [{'{'}{'\n'}
{'        '}<JK>"sheet_name"</JK>: <JS>"E&O Request"</JS>,{'\n'}
{'        '}<JK>"source_role"</JK>: <JS>"data"</JS>,{'\n'}
{'        '}<JK>"data_extracted"</JK>: {'{'}{'\n'}
{'          '}<JK>"insured_name"</JK>: <JS>"Mercury Public Affairs LLC"</JS>,{'\n'}
{'          '}<JK>"coverage_type"</JK>: <JS>"Errors & Omissions (E&O)"</JS>,{'\n'}
{'          '}<JK>"parent_company"</JK>: <JS>"Omnicom Group"</JS>{'\n'}
{'        }'}{'\n'}
{'      }]'}{'\n'}
{'    }'}{'\n'}
{'  ]'},{'\n'}
{'  '}<JK>"merged_extraction"</JK>: {'{'} <JC>{'// Unified from sparse email + XLSX sheets'}</JC>{'\n'}
{'    '}<JK>"coverage_type"</JK>: <JS>"E&O / Professional Liability"</JS>,{'\n'}
{'    '}<JK>"insured_name"</JK>: <JS>"Mercury Public Affairs LLC"</JS>,{'\n'}
{'    '}<JK>"certificate_holders"</JK>: [],{'\n'}
{'    '}<JK>"policies"</JK>: [<JS>"E&O"</JS>]{'\n'}
{'  }'},{'\n'}
{'  '}<JK>"completeness"</JK>: {'{'}{'\n'}
{'    '}<JK>"status"</JK>: <JS>"incomplete"</JS>,{'\n'}
{'    '}<JK>"fields_present"</JK>: [<JS>"insured_name"</JS>, <JS>"coverage_type"</JS>, <JS>"parent_company"</JS>],{'\n'}
{'    '}<JK>"fields_missing"</JK>: [<JS>"cert_holder_name"</JS>, <JS>"cert_holder_address"</JS>, <JS>"eo_limits"</JS>, <JS>"eo_deductible"</JS>, <JS>"effective_date"</JS>],{'\n'}
{'    '}<JK>"conflicts"</JK>: [<JS>"Email references 'GNAM' but XLSX names 'Mercury Public Affairs LLC'"</JS>]{'\n'}
{'  }'}{'\n'}
{`}`}
          </div>
        )}

        {activeExample === 'c' && (
          <div style={styles.jsonBlock}>
            <JC>{'// Real example: Jani-King COI request for GFL Holdco'}</JC>{'\n'}
{`{`}{'\n'}
{'  '}<JK>"request_id"</JK>: <JS>"REQ-2026-00224-001"</JS>,{'\n'}
{'  '}<JK>"email_metadata"</JK>: {'{'}{'\n'}
{'    '}<JK>"from"</JK>: <JS>"David Knight &lt;dknight@janiking.com&gt;"</JS>,{'\n'}
{'    '}<JK>"to"</JK>: <JS>"JanikingCerts@lockton.com"</JS>,{'\n'}
{'    '}<JK>"subject"</JK>: <JS>"FW: Jani-King and GFL Next Steps"</JS>,{'\n'}
{'    '}<JK>"received_at"</JK>: <JS>"2026-02-24T18:15:47Z"</JS>,{'\n'}
{'    '}<JK>"priority"</JK>: <JS>"normal"</JS>{'\n'}
{'  }'},{'\n'}
{'  '}<JK>"overall_classification"</JK>: {'{ '}<JK>"intent"</JK>: <JS>"new_certificate"</JS>, <JK>"confidence"</JK>: <JN>0.96</JN>{' }'},{'\n'}
{'  '}<JK>"sources"</JK>: [{'\n'}
{'    {'}{'\n'}
{'      '}<JK>"source_type"</JK>: <JS>"email_body"</JS>,{'\n'}
{'      '}<JK>"source_role"</JK>: <JS>"instructions_and_data"</JS>,{'\n'}
{'      '}<JK>"instructions_extracted"</JK>: [{'\n'}
{'        '}<JS>"Issue COI based on attached request form"</JS>,{'\n'}
{'        '}<JS>"Send David Knight a copy once completed"</JS>,{'\n'}
{'        '}<JS>"GFL must be listed as Certificate Holder"</JS>{'\n'}
{'      ]'},{'\n'}
{'      '}<JK>"data_extracted"</JK>: {'{'} <JC>{'// From forwarded thread (Jack Dalzell @ GFL)'}</JC>{'\n'}
{'        '}<JK>"certificate_holder"</JK>: <JS>"GFL Holdco (US) LLC"</JS>,{'\n'}
{'        '}<JK>"holder_address"</JK>: <JS>"1000 Social Street, Ste 1100, Raleigh, NC 27609"</JS>,{'\n'}
{'        '}<JK>"additional_insured"</JK>: <JS>"GFL Holdco (US) LLC, its subsidiaries and affiliates"</JS>,{'\n'}
{'        '}<JK>"primary_noncontributory"</JK>: <JN>true</JN>,{'\n'}
{'        '}<JK>"waiver_of_subrogation"</JK>: [<JS>"GL"</JS>, <JS>"Auto"</JS>, <JS>"Umbrella/Excess"</JS>, <JS>"WC/EL"</JS>],{'\n'}
{'        '}<JK>"cancellation_notice"</JK>: <JS>"30 days (10 days for non-payment)"</JS>{'\n'}
{'      }'}{'\n'}
{'    }'},{'\n'}
{'    {'}{'\n'}
{'      '}<JK>"source_type"</JK>: <JS>"docx_attachment"</JS>,{'\n'}
{'      '}<JK>"filename"</JK>: <JS>"GFL COI request.docx"</JS>,{'\n'}
{'      '}<JK>"source_role"</JK>: <JS>"data"</JS>,{'\n'}
{'      '}<JK>"data_extracted"</JK>: {'{'}{'\n'}
{'        '}<JK>"insured_name"</JK>: <JS>"Jani-King International, Inc."</JS>,{'\n'}
{'        '}<JK>"certificate_holder"</JK>: <JS>"GFL Holdco (US) LLC"</JS>,{'\n'}
{'        '}<JK>"coverage_types"</JK>: [<JS>"GL"</JS>, <JS>"Auto"</JS>, <JS>"Umbrella"</JS>, <JS>"WC"</JS>]{'\n'}
{'      }'}{'\n'}
{'    }'}{'\n'}
{'  ]'},{'\n'}
{'  '}<JK>"merged_extraction"</JK>: {'{'} <JC>{'// Unified from email chain + DOCX form'}</JC>{'\n'}
{'    '}<JK>"insured_name"</JK>: <JS>"Jani-King International, Inc."</JS>,{'\n'}
{'    '}<JK>"certificate_holders"</JK>: [{'{'} <JK>"name"</JK>: <JS>"GFL Holdco (US) LLC"</JS>, <JK>"address"</JK>: <JS>"1000 Social Street, Ste 1100, Raleigh, NC 27609"</JS> {'}'}],{'\n'}
{'    '}<JK>"additional_insureds"</JK>: [<JS>"GFL Holdco (US) LLC, its subsidiaries and affiliates"</JS>],{'\n'}
{'    '}<JK>"policies"</JK>: [<JS>"GL"</JS>, <JS>"Auto"</JS>, <JS>"Umbrella"</JS>, <JS>"WC"</JS>],{'\n'}
{'    '}<JK>"special_instructions"</JK>: [{'\n'}
{'      '}<JS>"Primary and non-contributory basis per written contract"</JS>,{'\n'}
{'      '}<JS>"Waiver of subrogation on GL, Auto, Umbrella/Excess, WC/EL"</JS>,{'\n'}
{'      '}<JS>"30 days prior written notice of cancellation (10 days for non-payment)"</JS>{'\n'}
{'    ]'}{'\n'}
{'  }'},{'\n'}
{'  '}<JK>"completeness"</JK>: {'{'}{'\n'}
{'    '}<JK>"status"</JK>: <JS>"complete"</JS>,{'\n'}
{'    '}<JK>"fields_present"</JK>: [<JS>"cert_holder"</JS>, <JS>"address"</JS>, <JS>"add_insured"</JS>, <JS>"coverage_types"</JS>, <JS>"special_instructions"</JS>],{'\n'}
{'    '}<JK>"fields_missing"</JK>: [],{'\n'}
{'    '}<JK>"conflicts"</JK>: []{'\n'}
{'  }'}{'\n'}
{`}`}
          </div>
        )}
      </div>

      {/* PHASE 4: ROUTING */}
      <PhaseDivider text="Step 4 — Routing & Admin Action" />

      <Connector height={20} />

      {/* Classification Cards */}
      <div className="achievement-cards" style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ ...styles.classCard, borderTop: '3px solid #059669' }}>
          <div style={styles.classIcon}>🆕</div>
          <h4 style={styles.classH4}>New Certificate</h4>
          <p style={styles.classP}>New vendor, project, or contract needing an ACORD cert</p>
        </div>
        <div style={{ ...styles.classCard, borderTop: '3px solid #2563EB' }}>
          <div style={styles.classIcon}>🔄</div>
          <h4 style={styles.classH4}>Renewal</h4>
          <p style={styles.classP}>Expiring or expired certificate requiring continuation</p>
        </div>
        <div style={{ ...styles.classCard, borderTop: '3px solid #D97706' }}>
          <div style={styles.classIcon}>✏️</div>
          <h4 style={styles.classH4}>Update</h4>
          <p style={styles.classP}>Modify existing cert — add insured, change limits, etc.</p>
        </div>
        <div style={{ ...styles.classCard, borderTop: '3px solid #E11D48' }}>
          <div style={styles.classIcon}>❓</div>
          <h4 style={styles.classH4}>Other</h4>
          <p style={styles.classP}>Ambiguous or non-certificate inquiry for manual triage</p>
        </div>
      </div>

      <Connector />

      {/* Task Created Node */}
      <div style={{
        ...styles.node,
        background: 'linear-gradient(135deg, #FFFFFF 0%, #E0F7FA 100%)',
        borderColor: '#67E8F9',
        maxWidth: 600,
        margin: '0 auto',
      }}>
        <div style={{ ...styles.nodeLabel, color: '#0891B2' }}>System Action</div>
        <div style={styles.nodeTitle}>Task Created with Full JSON Payload</div>
        <div style={styles.nodeDesc}>
          A structured task is generated with the complete JSON extraction attached,
          preserving full provenance of which data came from which source.
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 12 }}>
          {['Classification', 'Confidence Score', 'JSON Payload', 'Per-Source Breakdown', 'Missing Fields', 'Conflicts Flagged'].map(p => (
            <span key={p} style={styles.pill}>{p}</span>
          ))}
        </div>
      </div>

      <Connector />

      {/* Decision Diamond */}
      <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
        <div style={{ width: 220, height: 110, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(135deg, #FFFFFF, #FEF3C7)',
            border: '1.5px solid #FCD34D',
            transform: 'rotate(45deg)',
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(217,119,6,0.1)',
          }} />
          <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
            <div style={{ ...styles.nodeLabel, color: '#D97706' }}>Decision</div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0F172A' }}>Info Complete?</div>
          </div>
        </div>
      </div>

      <Connector height={24} />

      {/* Branch Container */}
      <div className="achievement-cards" style={{ maxWidth: 820, margin: '0 auto' }}>
        {/* Incomplete Branch */}
        <div style={{
          ...styles.node,
          background: 'linear-gradient(135deg, #FFFFFF 0%, #FFE4E6 100%)',
          borderColor: '#FCA5A5',
        }}>
          <span style={{ ...styles.branchLabel, background: '#FFE4E6', color: '#E11D48', border: '1px solid #FCA5A5' }}>
            ✗ Incomplete
          </span>
          <div style={{ ...styles.nodeLabel, color: '#E11D48' }}>Missing Information Path — Example B</div>
          <div style={styles.nodeTitle}>Generate Suggested Response</div>
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, marginTop: 14 }}>
            {[
              'Task status set to "Awaiting Info" — Omnicom E&O request missing cert holder, limits, deductible, and dates',
              'LLM drafts response to Christina Johnson listing missing fields, notes "GNAM" vs "Mercury" name conflict for clarification',
              'Suggested response attached to task for admin review',
              'Admin reviews, optionally edits, and sends with a single click',
              'When sender replies (possibly with updated XLSX), system re-decomposes all sources and updates task',
            ].map((text, i) => (
              <li key={i} style={styles.stepLi}>
                <span style={{ ...styles.stepNum, background: '#FFE4E6', color: '#E11D48' }}>{i + 1}</span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        {/* Complete Branch */}
        <div style={{
          ...styles.node,
          background: 'linear-gradient(135deg, #FFFFFF 0%, #D1FAE5 100%)',
          borderColor: '#6EE7B7',
        }}>
          <span style={{ ...styles.branchLabel, background: '#D1FAE5', color: '#059669', border: '1px solid #6EE7B7' }}>
            ✓ Complete
          </span>
          <div style={{ ...styles.nodeLabel, color: '#059669' }}>Sufficient Information Path — Examples A & C</div>
          <div style={styles.nodeTitle}>Prefill ACORD Form</div>
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, marginTop: 14 }}>
            {[
              'ACORD 25 selected — Example A: from PDF sample; Example C: from DOCX request form + email chain data',
              'Map merged_extraction: holder, limits, additional insureds, endorsement forms, waiver of subrogation, description of operations',
              'Task status → "Ready for Review" — Example A flagged URGENT; Example C normal priority',
              'Cert admin reviews prefilled form with source annotations showing which data came from email body vs. attachment',
              'Admin submits — A: sends to g.falaschetti@hemisystems.com; C: copy to dknight@janiking.com',
            ].map((text, i) => (
              <li key={i} style={styles.stepLi}>
                <span style={{ ...styles.stepNum, background: '#D1FAE5', color: '#059669' }}>{i + 1}</span>
                {text}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Loop Back */}
      <div style={styles.loopBack}>
        <span style={{ fontSize: 16 }}>↩️</span>
        <p style={{ fontSize: 12, color: '#5A6B82', lineHeight: 1.5, margin: 0 }}>
          <strong style={{ color: '#E11D48' }}>Re-processing loop:</strong> When a sender replies with missing information (including new attachments), the system re-decomposes all sources, re-runs per-source classification and extraction, rebuilds the JSON payload, and re-evaluates completeness — potentially moving the task from incomplete to complete automatically.
        </p>
      </div>

      {/* Footer */}
      <div style={styles.footerNote}>
        <p style={{ fontSize: 12, color: '#5A6B82', fontFamily: "'JetBrains Mono', monospace", margin: 0 }}>
          All LLM decisions logged per source with timestamps, confidence scores, and full audit trail
        </p>
      </div>
    </div>
  );
};

export default LLMClassificationDemo;
